<template>
    <div class="main">
        <!-- <div class="progress">
            <el-steps :active="3" align-center>
                <el-step title="注册"></el-step>
                <el-step title="个人认证"></el-step>
                <el-step title="资料审核"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>
        </div> -->
        <!-- <div class="box">
            <div></div>
            <div class="title">个人认证</div>
            <img @click="all('/Home')" src="../assets/icon／close@3x.png" alt="" />
        </div> -->
        <div class="top">
            <img src="../assets/login_img_shenhezhong@3x.png" alt="" />
            <h3>提交成功</h3>
            <p>个人申请认证提交成功，请等待系统审核</p>
            <div class="btn">
                <el-button type="primary" @click="all('/Home')">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-button {
    width: 110px;
    height: 36px;
    line-height: 6px;
    border-radius: 4px;
    margin: 50px 10px 0 65px;
}
/deep/ .el-steps {
    width: 800px;
    margin: auto;
    margin-top: 30px;
}
/deep/ .el-step__title.is-finish {
    color: #ffffff;
}
/deep/ .el-step__title.is-process {
    color: #cccccc;
    font-weight: 400 !important;
}
/deep/ .el-step__head.is-finish {
    border-color: #ffffff;
    color: #00684f;
}
/deep/.el-step:nth-child(4) {
    .el-step__icon {
        background: #9ec8be !important;
        color: #ffffff;
        border: 0;
    }
}

.main .appContainer {
    width: 100%;
}
.main {
    background: #ffffff !important;
    padding-bottom: 50px;
    .progress {
        height: 120px;
        background: #00684f;
        margin: -57px 0 50px 0 !important;
    }
    .box {
        width: 900px;
        height: 60px;
        .flex();
        background: linear-gradient(to right, #ffffff 0%, rgba(520, 226, 200, 0.2) 50%, #ffffff 100%);
        justify-content: space-between;
        box-shadow: -2px 0px 0px 0px #0092B1;
        margin: auto;
        .title {
            font-weight: 500;
            color: #0092B1;
            font-size: 16px;
        }
        img {
            width: 24px;
            height: 24px;
            z-index: 1;
        }
    }
    .top {
        margin: auto;
        img {
            width: 120px;
            height: 120px;
            padding-left: 58px;
        }
        h3 {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            line-height: 28px;
            margin: 24px 0 8px;
            padding-left: 83px;
        }
        p {
            font-size: 14px;
            font-weight: 400;
            color: #939599;
            line-height: 24px;
        }
    }
}
</style>
